import { useRef, useState } from "react";
import {
  Lightbulb,
  PieChartIcon,
  TrendingUp,
  ClipboardList,
  History,
} from "lucide-react";
import { Trends } from "../../components/Trends";
import TimeDropdown2 from "../../components/TimeDropdown2";
import EmotionsDistribution from "../../components/EmotionsDistribution";
import StudentDataWellnessSuccessTab2 from "../../components/StudentDataWellnessSuccessTab2";
import Recommendations from "../../components/Recommendations";
import BigFiveWellnessDataWrapper from "../../../../components/BigFiveWellnessData";

const StudentWellnessData = ({
  email,
  name,
  state,
  updateState,
  emotionPercents,
  user,
}) => {
  const pieRef = useRef(null);
  const bulbRef = useRef(null);
  const trendsRef = useRef(null);
  const clipboardRef = useRef(null);
  const historyRef = useRef(null);
  const [active, setActive] = useState("trends");
  const [isExpanded, setIsExpanded] = useState(false);

  const scrollTo = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div className="p-3 sm:p-0 lg:p-6 lg:border lg:border-[#DDDDDD] bg-white rounded lg:max-h-[64vh] 2xl:max-h-[70vh] lg:overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-[22px] sm:text-[24px] font-bold">
          {name && state.chosenStudent && state.chosenStudent !== "All Students"? `${name}'s Wellness Data` : "Wellness Data"}
        </h2>
        <div className="flex gap-1 sm:gap-3">
          <button
            className={`p-1 hover:bg-gray-100 border-b-2 ${
              active === "trends"
                ? "border-black text-black"
                : "border-transparent text-gray-600"
            }`}
            onClick={() => {
              scrollTo(trendsRef);
              setActive("trends");
            }}
            aria-label="Switch to Bar Chart"
          >
            <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            className={`p-1 hover:bg-gray-100 border-b-2 ${
              active === "bulb"
                ? "border-black text-black"
                : "border-transparent text-gray-600"
            }`}
            onClick={() => {
              scrollTo(bulbRef);
              setActive("bulb");
            }}
            aria-label="Switch to Bar Chart"
          >
            <Lightbulb className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            className={`p-1 hover:bg-gray-100 border-b-2 ${
              active === "pie"
                ? "border-black text-black"
                : "border-transparent text-gray-600"
            }`}
            onClick={() => {
              scrollTo(pieRef);
              setActive("pie");
            }}
            aria-label="Switch to Pie Chart"
          >
            <PieChartIcon className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            className={`p-1 hover:bg-gray-100 border-b-2 ${
              active === "clipboard"
                ? "border-black text-black"
                : "border-transparent text-gray-600"
            }`}
            onClick={() => {
              scrollTo(clipboardRef);
              setActive("clipboard");
            }}
            aria-label="Switch to Bar Chart"
          >
            <ClipboardList className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            className={`p-1 hover:bg-gray-100 border-b-2 ${
              active === "history"
                ? "border-black text-black"
                : "border-transparent text-gray-600"
            }`}
            onClick={() => {
              scrollTo(historyRef);
              setActive("history");
            }}
            aria-label="Switch to History"
          >
            <History className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 self-start items-center gap-4 mb-4 sm:mb-8">
        <div className="flex-shrink-0 self-start">
          <TimeDropdown2 state={state} updateState={updateState} />
        </div>
      </div>
      <div ref={trendsRef} className="mb-4">
        <Trends
          studentEmail={email}
          state={state}
          updateState={updateState}
          emotionPercents={emotionPercents}
          name={name}
        />
      </div>
      <div ref={bulbRef} className="mb-4">
        <Recommendations
          studentEmail={email}
          state={state}
          updateState={updateState}
          emotionPercents={emotionPercents}
          name={name}
        />
      </div>
      <div ref={pieRef} className="mb-4">
        <EmotionsDistribution
          studentEmail={email}
          state={state}
          updateState={updateState}
          emotionPercents={emotionPercents}
          name={name}
        />
      </div>
      <div ref={clipboardRef} className="mb-4">
        <StudentDataWellnessSuccessTab2
          studentEmail={email}
          state={state}
          updateState={updateState}
          expanded={isExpanded}
          setExpanded={setIsExpanded}
          name={name}
        />
      </div>
      <div
        ref={historyRef}
        className="mb-4 flex-1 bg-white shadow rounded p-3 sm:p-4 2xl:p-8"
      >
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <History className="w-5 h-5 text-600 shrink-0" />
            <h3 className="text-[22px] sm:text-[24px] font-bold">
            {name && state.chosenStudent && state.chosenStudent !== "All Students"
            ? `${name}'s Wellness History`
                : "Wellness History"}
            </h3>
          </div>
        </div>
        <BigFiveWellnessDataWrapper
          state={state}
          updateState={updateState}
          adultActionImages={user?.adultActionImages}
        />
      </div>
    </div>
  );
};

export default StudentWellnessData;
